var app_comscore_table_setup = $('#app-comscore-table-setup');

if (app_comscore_table_setup.length) {
    function initializeComscoreSetupTable() {
        window.app_comscore_table_setup.DataTable({
            ajax: {
                url: '/comscore/books/processing',
                dataSrc: 'data'
            },
            columns: [
                {data: 'id'},
                {data: 'agency_name'},
                {data: 'market_name'},
                {data: 'month'},
                {data: 'active'},
                {data: 'status'},
                {data: 'networks_status'}
            ],
            editable: false,
            destroy: true,
            pageLength: user_entries,
            lengthMenu: [
                [10, 25, 50, -1],
                [10, 25, 50, 'All'],
            ],
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = ' <div class="checkbox checkbox-danger books_check"> ' +
                            '<input class="checkbox" class="form-control" type="checkbox" ' + ((rowData.status !== 'Completed' || rowData.networks_status !== 'done') ? 'disabled' : '') + '  id="' + rowData.id + '" name="selected_campaigns[]" value="' + rowData.id + '" >' +
                            '<label for="' + rowData.id + '"> </label>' +
                            '</div>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 3,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        var aux = rowData.month.split('-');
                        html = aux[1]+'/'+aux[2]+'/'+aux[0];
                        $(td).html(html);
                    }
                },
                {
                    "targets": 4,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(rowData.active)
                            html = '<span class="btn btn-outline btn-success">Active</span>';
                        else
                            html = '<span class="btn btn-outline btn-danger">Hold</span>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 5,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(rowData.status === 'Completed')
                            html = '<span class="btn btn-outline btn-success">Completed</span>';
                        else if(rowData.status === 'Queued')
                            html = '<span class="btn btn-outline btn-info">Queued</span>';
                        else
                            html = '<span class="btn btn-outline btn-danger">Processing</span>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 6,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(rowData.networks_status === 'done')
                            html = '<span class="btn btn-outline btn-success">Completed</span>';
                        else if(rowData.networks_status === 'queue')
                            html = '<span class="btn btn-outline btn-info">Queued</span>';
                        else
                            html = '<span class="btn btn-outline btn-danger">Processing</span>';
                        $(td).html(html);
                    }
                }
            ]
        });
    }

    initializeComscoreSetupTable();

    $('#select_all_books').on('click', function (e) {
        $('#app-comscore-table-setup  input:checkbox').each(function () {
            if ($(this).prop('disabled')=== false)
                $(this).prop('checked', true);
        });
    });
    $('#deselect_all_books').on('click', function (e) {
        $('#app-comscore-table-setup input:checkbox').prop('checked', false);
    });

    $('#refresh_books_table').on('click', function (e) {
        initializeComscoreSetupTable();
    });

    $('#activate_multiple_books').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        $('.books_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
            }
        });
        var ms = "Are you sure to activate these books?";
        if (selectedItems.length > 0){
            var r = confirm(ms);
            if(r){
                show_loader();
                var params = {
                    books: selectedItems,
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: url,
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        global_notification('success', 'Books activated.');
                        initializeComscoreSetupTable();
                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);

                    }
                });
            }
        }
        else{
            alert('Please select at least one Book.');
        }
    });

    $('#deactivate_multiple_books').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        $('.books_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
            }
        });
        var ms = "Are you sure to deactivate these books?";
        if (selectedItems.length > 0){
            var r = confirm(ms);
            if(r){
                show_loader();
                var params = {
                    books: selectedItems,
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: url,
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        global_notification('success', 'Books deactivated.');
                        initializeComscoreSetupTable();
                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);

                    }
                });
            }
        }
        else{
            alert('Please select at least one Book.');
        }
    });
}